var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"importResult"},[_c('PublicTable',{ref:"dialogTable",attrs:{"data-source":_vm.dataSource},on:{"sizeChange":_vm.changeSize,"currentChange":_vm.changeNum,"handleSelection":_vm.publicTableHandleSelectionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }